import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {ProcessMappingStepOutput} from './ProcessMappingStepOutput';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class ProcessMappingStepInput extends BasicEntity {
condition: string;
description: TranslatedEmb;
field: string;
fieldFormat: string;
fieldType: string;
label: TranslatedEmb;
orderNumber: number | null;
orderedOutputs: ProcessMappingStepOutput[];
ouputs: ProcessMappingStepOutput[];
outputs: ProcessMappingStepOutput[];
parentField: string;
processCode: string;
processMappingStepcode: string;
visionCode: string;
}

